























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    TransportParty,
    TransportTask,
} from "@/models";

import { transportUnitService } from "@/services";

import MissingUnitDialog from "./MissingUnitDialog.vue";

@Component({
    components: {
        MissingUnitDialog
    }
})
export default class FindUnitDialog extends Vue {
    @Prop() task!: TransportTask;
    @Prop() party!: TransportParty;

    unitNumber = "";
    searching = false;

    missing = false;

    async search() {
        this.searching = true;

        const units = await transportUnitService.searchUnits({ unitNumber: [this.unitNumber], active: true });

        if (units.items.length) {
            this.$emit("input", units.items[0]);
            return;
        } else {
            this.missing = true;
        }

        this.searching = false;
    }
}
